'use client'

import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { MapPin } from 'lucide-react'
import { useEffect, useRef } from 'react'
import ReactDOMServer from 'react-dom/server'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'

// Create a custom icon using the Lucide MapPin
const icon = L.divIcon({
  html: ReactDOMServer.renderToString(
    <MapPin
      className="w-6 h-6"
      color="#2563eb"
      fill="transparent"
      strokeWidth={3}
    />
  ),
  className: 'custom-marker-icon',
  iconSize: [24, 24],
  iconAnchor: [12, 24],
  popupAnchor: [0, -24],
})

export interface MapProps {
  center: [number, number]
  zoom?: number
  markers?: Array<{
    position: [number, number]
    popup?: string
  }>
}

const MapClient = ({
  center = [51.505, -0.09] as [number, number],
  zoom = 16,
  markers = []
}: MapProps) => {
  const mapRef = useRef<L.Map>(null)

  useEffect(() => {
    const map = mapRef.current
    if (!map) return

    if (!center || !Array.isArray(center) || center.length !== 2) {
      console.warn('Invalid center coordinates provided to MapClient: ', center)
      return
    }

    map.whenReady(() => {
      map.setView(center, zoom)
    })
  }, [center, zoom])

  if (!center || !Array.isArray(center) || center.length !== 2) {
    return <div>Invalid map coordinates</div>
  }

  return (
    <>
      <MapContainer
        ref={mapRef}
        center={center}
        zoom={zoom}
        scrollWheelZoom={false}
        className="h-full w-full rounded-lg"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {markers.map((marker, index) => (
          <Marker
            key={index}
            position={marker.position}
            icon={icon}
          >
            {marker.popup && <Popup>{marker.popup}</Popup>}
          </Marker>
        ))}
      </MapContainer>
    </>
  )
}

export default MapClient 